import React from "react";
import CompanyLogoSVG from "./selectcup-imgs/company-logo.svg";
import FirstExample from "./selectcup-imgs/example1-3x.png";
import LastExample from "./selectcup-imgs/example2-3x.png";
import LowerRightHandSVG from "./selectcup-imgs/lower-right.svg";
import { RightHandSVG } from "./selectcup-imgs/RightHandSVG";
import MainLogoSVG from "./selectcup-imgs/main-logo.svg";
import MainLogoPCSVG from "./selectcup-imgs/main-logo-pc.svg";
import ManyPersonSVG from "./selectcup-imgs/many-person.svg";
import SmallLogo from "./selectcup-imgs/small-logo.svg";
import styles from "./SelectCup.module.scss";
import { PersonSVG } from "./selectcup-imgs/PersonSVG";
import FennelLogo from "./selectcup-imgs/logo_fennel2x.png";
import SelectLogoSVG from "./selectcup-imgs/select-logo.svg";

const SelectCup: React.FC = () => {
  return (
    <div className={styles["selectcup"]}>
      <div className={styles["selectcup__top__container"]}>
        <div className={styles["selectcup__top"]}>
          <div className={styles["main-logo"]}>
            {window.innerWidth >= 768 ? (
              <img src={MainLogoPCSVG} />
            ) : (
              <img src={MainLogoSVG} />
            )}
          </div>

          <div className={`${styles["logo-box"]} ${styles["left"]}`}>
            <img src={LowerRightHandSVG} className={styles["hand-logo"]} />

            <img
              src={SmallLogo}
              className={`${styles["small-logo"]} ${styles["left"]}`}
            />

            <img
              src={LowerRightHandSVG}
              className={`${styles["hand-logo"]} ${styles["upper-right"]}`}
            />
          </div>

          <div className={`${styles["logo-box"]} ${styles["right"]}`}>
            <img
              src={LowerRightHandSVG}
              className={`${styles["hand-logo"]} ${styles["lower-left"]}`}
            />

            <img
              src={SmallLogo}
              className={`${styles["small-logo"]} ${styles["right"]}`}
            />

            <img
              src={LowerRightHandSVG}
              className={`${styles["hand-logo"]} ${styles["upper-left"]}`}
            />
          </div>

          <img src={CompanyLogoSVG} className={styles["company-logo"]} />

          <img src={ManyPersonSVG} className={styles["many-person"]} />
        </div>
      </div>
      <div className={styles["selectcup__contents"]}>
        <div className={styles["selectcup__inner"]}>
          <div>
            <div className={styles["contents-title"]}>
              <span className={styles["contents-title__main"]}>CONCEPT</span>
              <span className={styles["contents-title__sub"]}>コンセプト</span>
            </div>
          </div>
          <div className={styles["concept-text"]}>
            <p>昨年7月18日に開催した、</p>
            <p className={styles["big"]}>
              <span>“FFLSELeCTCUP”</span>が帰ってくる!!
            </p>
            <p>
              招待した有名実力派ストリーマー20名がプロ20チームを
              <span>ドラフト形式</span>
              で選択。
            </p>
          </div>
          <div className={`${styles["border-leftBox"]} ${styles["futura"]}`}>
            example
          </div>
          <div className={styles["flex-box"]}>
            <img src={FirstExample} className={styles["example"]} />
            <img src={LastExample} className={styles["example"]} />
          </div>
          <div className={styles["concept-text"]}>
            <p>ストリーマーとプロ選手による</p>
            <p className={styles["big"]}>
              唯一無二の<span>ドリームマッチ</span>
            </p>
            <p>をお届けします。</p>
          </div>
        </div>

        <div className={styles["selectcup__inner"]}>
          <div>
            <div className={styles["contents-title"]}>
              <span className={styles["contents-title__main"]}>DETAIL</span>
              <span className={styles["contents-title__sub"]}>
                大会日程詳細
              </span>
            </div>
          </div>

          <div className={styles["flex-box"]}>
            <div
              className={`${styles["border-leftBox"]} ${styles["inline-flex"]}`}
            >
              <span>大会名</span>
              <span>FFLSELeCTCUP #2</span>
            </div>
            <div
              className={`${styles["border-leftBox"]} ${styles["inline-flex"]}`}
            >
              <span>主催</span>
              <span>株式会社FENNEL</span>
            </div>
            <div
              className={`${styles["border-leftBox"]} ${styles["inline-flex"]}`}
            >
              <span>開催日時</span>
              <span>2022年1月28日(金)</span>
            </div>
            <div
              className={`${styles["border-leftBox"]} ${styles["inline-flex"]}`}
            >
              <span>放送時間</span>
              <span>19:00～22:45</span>
            </div>
          </div>
        </div>

        <div className={styles["selectcup__inner"]}>
          <div>
            <div className={styles["contents-title"]}>
              <span className={styles["contents-title__main"]}>LAST TIME</span>
              <span className={styles["contents-title__sub"]}>
                前大会の詳細
              </span>
            </div>
          </div>

          <div className={styles["link-box"]}>
            <a
              href="https://www.youtube.com/watch?v=6lUFNBrOuCY"
              rel="nofollow noopener noreferrer"
              target="_blank"
              className={styles["link"]}
            >
              <RightHandSVG class_name={styles["right-hand"]} />
              前大会の配信はコチラ
            </a>
          </div>

          <div className={styles["border-leftBox"]}>前回出場選手一覧</div>
          <div className={styles["player-list"]}>
            <dl>
              <dt>
                <PersonSVG width={17.36} />
                ストリーマー
              </dt>
              <dd>葛葉、勇気ちひろ、叶、BobsappAim、TIE_Ru、はつめ など</dd>
            </dl>
            <dl>
              <dt>
                <PersonSVG width={17.36} />
                海外プロプレイヤー
              </dt>
              <dd>
                TSM Reps、TSM Snip3down、Torrent Euriece、Reignite
                Genburten、Riddle obly、Riddle Pakha
              </dd>
            </dl>
            <dl>
              <dt>
                <PersonSVG width={17.36} />
                プロチーム
              </dt>
              <dd>FENNEL、RIG North、Flora、UNITEなど</dd>
            </dl>
          </div>
        </div>

        <div className={styles["selectcup__inner"]}>
          <div className={styles["contents-title"]}>
            <span className={styles["contents-title__main"]}>
              ORGANIZING COMPANY
            </span>
            <span className={styles["contents-title__sub"]}>主催会社情報</span>
          </div>

          <div className={styles["fennel-logo"]}>
            <img src={FennelLogo} />
          </div>

          <div className={styles["fennel-explanation"]}>
            Eスポーツのチーム運営や大会リーグ『FFL』運営、ストリーマー育成、ファッション事業など幅広い活動を展開しています。
            <br></br>
            FennelはメンバーのTwitter総フォロワー数が150万人を超し、横浜に国内最高水準の練習環境『FENNELベース』を設立など、現在国内で最も急成長していると言われているeスポーツ会社の1つです。
            <br></br>
            eスポーツをカルチャライズし、人が人生をかけて熱狂できるコミュニティを創造する。
            <br></br>
            Fennelは「eスポーツに熱狂を。」のミッションを達成するべく、コミュニティと距離が近く、コミュニティを導く旗振り役となるような組織を構築します。
          </div>
        </div>
        <div className={styles["selectcup__inner"]}>
          <div className={styles["contents-title"]}>
            <span className={styles["contents-title__main"]}>PARTNERS</span>
            <span className={styles["contents-title__sub"]}>パートナーズ</span>
          </div>

          <div className={styles["select-logo"]}>
            <img src={SelectLogoSVG} />
          </div>
        </div>
      </div>
      <div className={styles["selectcup__inner"]}>
        <div className={styles["selectcup__bottom"]}>
          <div className={styles["speech-bubbles"]}>インターン企画開催中!!</div>
          <div className={styles["link-box"]}>
            <a
              href="https://esports-select.com/project/61c17acc62d8ba4f5728a962/"
              rel="nofollow noopener noreferrer"
              target="_blank"
              className={styles["link"]}
            >
              <RightHandSVG class_name={styles["right-hand"]} />
              応募詳細はコチラ
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectCup;
